// extracted by mini-css-extract-plugin
export var icon = "_4g-1";
export var subtext = "_4g-0";